export default "__VITE_ASSET__20aab23e__"